import api from "@/api/viktor"

export async function logout() {
  const response = await api({
    method: "post",
    url: "/auth/logout",
  })

  return response
}
